<kendo-dialog *ngIf="selectDirectorySourceDialogOpened" (close)="close()" [width]="450">
    <kendo-dialog-titlebar>
        <h3>{{ 'PROVIDER-DIRECTORY-SOURCES' | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="sourceForm" class="k-form" (keydown)="keyDown($event)">
        <div class="row mt-3">
            <div class="col">
                <kendo-combobox id="directorySource" formControlName="directorySource" [data]="filteredDirectorySources"
                    [textField]="'text'" [valueField]="'id'" class="w-100" tabindex="1">
                </kendo-combobox>
            </div>
        </div>
    </form>
    <kendo-dialog-actions>
        <button class="k-button" (click)="close()">{{ 'CANCEL' | translate }}</button>
        <button class="k-button k-primary" (click)="onSourceSelection()"
            [disabled]="!sourceForm.valid || !sourceForm.dirty || !directorySource.value || !directorySource.value.id">
            {{'SELECT' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>